import React from 'react';
import styles from '../utils/app.scss';
import Helmet from 'react-helmet';
import favicon from '../../static/favicon.png';

export default ({ children }) => (
  <div style={{ margin: `0 auto`}}>
  	<Helmet
	  title='Type@Cooper West 2018'
	  meta={[
	      { name: 'description', content: 'Type@Cooper West 2018' },
	      { name: 'keywords', content: 'type design, cooper union, letterform archive' },
	  ]}
	  link={[
	      { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` },
	      { rel: 'icon', type: 'image/png', href: `${favicon}` }
	  ]}
	/>
    {children()}
  </div>
);


// WEBPACK FOOTER //
// ./src/layouts/index.js